import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { diagramByIdSelector } from '../selectors';
import { deleteDiagramItem } from '../actions/entry';
import Edge from '../components/Diagram/Edge';

const makeMapStateToProps = (
  state,
  {
    id,
    source,
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    style,
    arrowHeadType,
    markerEndId,
  },
) => {
  let isPowerLine = false;
  const sourceNode = diagramByIdSelector(state, source);
  if (sourceNode && sourceNode.diagram?.type === 'powerNode') isPowerLine = true;
  return {
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    style,
    arrowHeadType,
    markerEndId,
    isPowerLine,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onDeleteEdge: deleteDiagramItem,
    },
    dispatch,
  );

export default connect(makeMapStateToProps, mapDispatchToProps)(Edge);
